import { TableAction, TableDataSchema } from '@brasshq/ui-kit';
import { EmptyScreenProps } from 'src/sharedComponents/EmptyScreen';
import NameWithAvatar from 'src/sharedComponents/NameWithAvatar';
import { HandlePermission, TFunc } from 'src/types';
import { TeamInvite } from 'src/types/entities/administration';
import { truncate } from 'src/utils/genericUtils';

import { TeamMatesDialogType, TeamMatesTableState } from '../types';

import styles from '../components/TeamMatesTable/TeamMatesTable.module.scss';

export function createActions(
  handleStateUpdate: TFunc<Partial<TeamMatesTableState>>,
  handlePermissions: HandlePermission,
): TableAction<TeamInvite>[] {
  const isPermitted = handlePermissions(['team.invite', 'team.manage'], true);
  return [
    {
      label: 'Resend invite',
      onClick: activeRowData =>
        handleStateUpdate({
          showDialog: true,
          activeRowData,
          dialogType: TeamMatesDialogType.ResendInvite,
        }),
      handleVisibility: () => !isPermitted,
    },
    {
      label: 'Delete invite',
      onClick: activeRowData =>
        handleStateUpdate({
          showDialog: true,
          activeRowData,
          dialogType: TeamMatesDialogType.DeleteInvite,
        }),
      handleVisibility: () => !isPermitted,
    },
  ];
}

export function createDataSchema(): TableDataSchema<TeamInvite>[] {
  return [
    {
      name: (
        <span className={styles.TeamMatesTable_account_name_header}>
          Account name
        </span>
      ),
      render: row => (
        <NameWithAvatar
          firstname={row?.firstname}
          lastname={row?.lastname}
          isVerified={false}
        />
      ),
    },
    {
      name: 'Email',
      accessor: 'email',
    },
    {
      name: 'Role',
      render: row => row?.role?.data?.display_name || '',
    },
    {
      name: 'Invited by',
      render: ({ invited_by }) =>
        truncate(
          `${invited_by?.data?.firstname || ''} ${
            invited_by?.data?.lastname || ''
          }`,
          28,
        ),
    },
  ];
}

export function createEmptyState(): EmptyScreenProps {
  return {
    title: 'No sent invite',
    subText:
      'To invite your team mates to your company’s Brass account, click on the plus icon below.',
  };
}
